import { render, staticRenderFns } from "./PatternUserTableStatus.vue?vue&type=template&id=b870cae6&scoped=true&"
import script from "./PatternUserTableStatus.vue?vue&type=script&lang=js&"
export * from "./PatternUserTableStatus.vue?vue&type=script&lang=js&"
import style0 from "./PatternUserTableStatus.vue?vue&type=style&index=0&id=b870cae6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b870cae6",
  null
  
)

export default component.exports